export default __webpack_public_path__ + "static/media/union.ba79e1fc.png";